import { render, staticRenderFns } from "./RirekishoEsfDetailCard.vue?vue&type=template&id=5a6508cf"
import script from "./RirekishoEsfDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoEsfDetailCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports